import { Auth } from "aws-amplify";
import { Hub } from "aws-amplify";

import { Authenticator } from "@aws-amplify/ui-react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useContext } from "react";
import * as React from "react";
import { View } from "@aws-amplify/ui-react";
import IconButton from "@mui/material/IconButton";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CloseIcon from "@mui/icons-material/Close";
import LogoutIcon from "@mui/icons-material/Logout";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import Tooltip from "@mui/material/Tooltip";
import Fab from "@mui/material/Fab";
import {
  Typography,
  Modal,
  Box,
  Grid,
  Menu,
  MenuItem,
} from "@mui/material";

import Subscribe from "../payment/Subscribe.js";
import PauseSubscription from "../payment/PauseSubscription.js";
import ReactivateSubscription from "../payment/ReactivateSubscription.js";
import { CognitoUserContext } from "../contexts/cognitoUserContext.js";
import {
  CognitoUserSignedIn,
  CognitoUserSubscriptionNotActive,
  CognitoUserSubscriptionActive,
  CognitoUserSubscriptionPaused
} from "../services/user/userStatusService";
import { userIsAdministrator } from "../services/user/cognitoService";
import { useNavigate } from "react-router-dom";

const AUTHENTICATED = "authenticated";

export default function SignInManager() {

  const { cognitoUser, setCognitoUser } = useContext(CognitoUserContext);
  const navigate = useNavigate();

  //const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const { user, authStatus } = useAuthenticator((context) => [context.user]);

  const getIsAuthenticated = () => {
    return authStatus === AUTHENTICATED;
  };

  // Wit this, user is 'undefined' or the full object, so we can use it here

  // Move setState to useEffect to avoid render-time updates
  React.useEffect(() => {
    if (getIsAuthenticated()) {
      setCognitoUser(user);
    }
  }, [user, authStatus, setCognitoUser]);


  function getUsername() {
    try {
      return cognitoUser["username"];
    } catch (error) {
      return null;
    }
  }
  function getInitial() {
    const username = getUsername();
    try {
      return username.substring(0, 1).toUpperCase();
    } catch (error) {
      return "?";
    }
  }

  hubAuthListener(); // Listener does not get any events during refresh

  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);

  const [modalOpen, setModalOpen] = React.useState(false);
  // No more lines of procedural code execution in this script
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleModalOpen = () => {
    setModalOpen(true);
    handleMenuClose();
  };
  const handleModalClose = () => {
    setModalOpen(false);
  };

  async function logOut() {
    handleMenuClose();
    try {
      await Auth.signOut();
      // Hub listener will handle state cleanup automatically
    } catch (error) {
      console.error("Error signing out:", error);
    }
  }

  function handleAdminClick() {
    handleMenuClose();
    navigate('/');
    window.location.reload(); // Reload to ensure admin view renders
  }

  function hubAuthListener() {
    Hub.listen("auth", (data) => {

      switch (data.payload.event) {
        case "autoSignIn":
          handleModalClose();

          break;
        case "signIn":
          handleModalClose();


          break;
        case "signUp":

          break;
        case "signOut":
          setCognitoUser(null);

          break;
        case "signIn_failure":

          break;
        case "configured":
          break;
        default:
         
          break;
      }
    });
  }
  return (
    <View>
      <Fab
        color="secondary"
        aria-label="add"
        id="basic-button"
        aria-controls={menuOpen ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? "true" : undefined}
        onClick={handleClick}
        size="small"
      >
        <Tooltip title={getUsername()}>
          <Typography
            sx={{
              fontSize: 20,
            }}
          >
            {getInitial()}
          </Typography>
        </Tooltip>
      </Fab>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={handleModalOpen}
          disabled={CognitoUserSignedIn(cognitoUser)}
        >
          <Tooltip title="Sign In/Up">
            <PersonOutlineIcon />
          </Tooltip>
        </MenuItem>
        <Box
          sx={{
            display: CognitoUserSignedIn(cognitoUser) ? "inline" : "none",
          }}
        >
          <Subscribe
            visible={CognitoUserSubscriptionNotActive(cognitoUser)}
          />
          <PauseSubscription
            visible={CognitoUserSubscriptionActive(cognitoUser)}
          />
          <ReactivateSubscription
            visible= {CognitoUserSubscriptionPaused(cognitoUser)}
          />
        </Box>
        {userIsAdministrator(cognitoUser) && (
          <MenuItem onClick={handleAdminClick}>
            <Tooltip title="Administration">
              <AdminPanelSettingsIcon />
            </Tooltip>
          </MenuItem>
        )}
        <MenuItem disabled={!CognitoUserSignedIn(cognitoUser)} onClick={logOut}>
          <Tooltip title="Log Out">
            <LogoutIcon />
          </Tooltip>
        </MenuItem>
      </Menu>
      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="flex-end"
          >
            <IconButton
              sx={{ color: "white" }}
              onClick={handleModalClose}
            >
              <CloseIcon />
            </IconButton>
          </Grid>

          <Authenticator />
        </Grid>
      </Modal>
    </View>
  );
}
